<template>
  <div class="container">
    <div class="title">
      <img @click="handleBack" style="width: 24px; height: 24px" src="../assets/back.png" />
      <div>工作汇报</div>
    </div>
    <div class="work_report_tab">
      <div :class="[type === 1 ? 'select' : '']" @click="changeType(1)">日报</div>
      <div :class="[type === 2 ? 'select' : '']" @click="changeType(2)">汇报管理</div>
    </div>
    <div v-if="type === 1">
      <div class="daily-content">
        <ul class="search-tabs">
          <li v-if="hasPermission" :class="[approvalType === 1 ? 'active' : '']" @click="changeTitle(1)">我的</li>
          <li :class="[approvalType === 2 ? 'active' : '']" @click="changeTitle(2)">我审核的</li>
          <li :class="[approvalType === 3 ? 'active' : '']" @click="changeTitle(3)">抄送我的</li>
          <li :class="[approvalType === 4 ? 'active' : '']" @click="changeTitle(4)">公开的</li>
        </ul>
        <div class="daily-search">
          <div @click="changeTime">{{ currentDateStr }}</div>
          <van-dropdown-menu v-if="approvalType !== 1">
            <van-dropdown-item @change="changeStatus" v-model="typeValue" :options="typeOption" />
          </van-dropdown-menu>
          <div style="width: 112.5px;height: 48px;" v-else></div>
        </div>
        <van-search v-model="searchValue" show-action placeholder="请输入姓名">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <div class="daily-item" @click="handleClick(item)" v-for="(item, index) in taskList" :key="index">
          <div class="member-info">
            <img v-if="handleAvatar(item)" style="width: 40px;height: 40px;margin-right: 8px" :src="item.avatar" />
            <div v-else class="member-bg">{{ renderName(item.staffName) }}</div>
            <div>
              <div>{{ item.staffName }}</div>
              <div>部门：{{ item.officeName }}</div>
              <div>职位：{{ item.position }}</div>
            </div>
          </div>
          <div :style="handleColor(item, index)">
            {{ handelRender(item) }}
          </div>
        </div>
        <div class="daily-footer">
          <div class="daily-submit" @click="jumpEdit">写日报</div>
        </div>
      </div>
      <van-popup v-model="showPicker" position="bottom">
        <van-datetime-picker v-model="currentDate" type="date" title="选择年月日" @confirm="data => onConfirm(data)" @cancel="showPicker = false" />
      </van-popup>
    </div>
    <div v-if="type === 2">
      <div class="report_search">
        <!-- <van-dropdown-menu>
          <van-dropdown-item @change="changeStatus" v-model="reportValue" :options="reportList" />
        </van-dropdown-menu> -->
        <!-- <div @click="changeMonth">{{ currentMonthStr }}</div> -->
        <div class="end_date">汇报管理的数据可以在OA审批中查阅。</div>
        <div class="screen" @click="showScreen = true">
          <div>筛选</div>
          <img style="width:0.5rem;height:0.5rem" src="@/assets/screen.png" />
        </div>
      </div>
      <ul class="search-tabs" @click="changeReportTabs">
        <van-badge v-if="total > 0" :content="total">
          <li :class="[reportType == 1 ? 'active' : '']" id="1">待处理</li>
        </van-badge>
        <li v-else :class="[reportType == 1 ? 'active' : '']" id="1">待处理</li>
        <li :class="[reportType == 2 ? 'active' : '']" id="2">已处理</li>
        <li :class="[reportType == 3 ? 'active' : '']" id="3">已发起</li>
        <li :class="[reportType == 4 ? 'active' : '']" id="4">抄送我的</li>
        <li :class="[reportType == 5 ? 'active' : '']" id="5">草稿箱</li>
      </ul>
      <van-search v-model="searchWord" show-action placeholder="请输入流程名称搜索">
        <template #action>
          <div @click="onReportSearch">搜索</div>
        </template>
      </van-search>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <van-cell v-for="(item, index) in approvalList" :key="index" class="approval_list" @click="toApplyForm(item)">
            <img v-if="item.avatar" :src="item.avatar" class="member_img" />
            <img v-else src="@/assets/default.png" class="member_img" />
            <div>
              <div>{{ item.initiatorName }}</div>
              <div>流程名称：{{ item.title }}</div>
              <div>提交时间：{{ dayjs(item.createDate).format('YYYY-MM-DD HH:mm:ss') }}</div>
            </div>
            <div v-if="reportType != 5" :style="renderColor(item)">{{ renderStatus(item) }}</div>
            <div v-if="reportType == 5">
              <span style="color:#1584ff;" @click.stop="jumpApplyForm(item)">待提交</span>
              |
              <span style="color:#1584ff;" @click.stop="delApproval(item)">删除</span>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>
      <div class="daily-footer">
        <div class="daily-submit" @click="handleReport">写汇报</div>
      </div>
      <van-popup v-model="showMonthPicker" position="bottom">
        <van-datetime-picker v-model="currentDate" type="year-month" title="选择年月" @confirm="data => onMonthConfirm(data)" @cancel="showMonthPicker = false" />
      </van-popup>
      <van-popup v-model="showScreen" class="screen_box" position="bottom">
        <div class="screen_title">筛选</div>
        <div class="screen_select_title" v-if="reportType != 5">状态</div>
        <div class="screen_status" v-if="reportType != 5">
          <div :class="[selectStatus === 0 ? 'select' : '']" @click="selectStatus = 0">全部</div>
          <div :class="[selectStatus === 1 ? 'select' : '']" @click="selectStatus = 1">审批完成</div>
          <div :class="[selectStatus === 2 ? 'select' : '']" @click="selectStatus = 2">审批中</div>
          <div :class="[selectStatus === 3 ? 'select' : '']" @click="selectStatus = 3">已撤销</div>
          <div :class="[selectStatus === 4 ? 'select' : '']" @click="selectStatus = 4">退回</div>
        </div>
        <div class="screen_select_title">表单</div>
        <div class="screen_status">
          <div v-for="(item, index) in reportList" :key="index" :class="[selectModel === item.value ? 'select' : '']" @click="selectModel = item.value">
            {{ item.text }}
          </div>
        </div>
        <div class="btn_box">
          <div @click="reset" class="reset_btn">重置</div>
          <div @click="confirmScreen" class="confirm_btn">确定</div>
        </div>
      </van-popup>
      <van-popup v-model="showApprovalModel" position="bottom">
        <van-picker title="选择审批单" show-toolbar :columns="columns" :columns-field-names="customFieldName" @confirm="writeReport" @cancel="showApprovalModel = false" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import { setMainStaff, getTaskList, getReportList, getReportApprovalList, delApproval, writeDailyPermission } from '../axios/services';
import { Dialog } from 'vant';
import { mapState } from 'vuex';
import { Toast } from 'vant';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      type: 1,
      approvalType: 1,
      searchValue: '',
      typeValue: 3,
      reportValue: 'all',
      reportList: [],
      typeOption: [
        { text: '未填写', value: 0 },
        { text: '未审核', value: 1 },
        { text: '已审核', value: 2 },
        { text: '全部', value: 3 }
      ],
      showPicker: false,
      currentDate: new Date(),
      currentDateStr: this.handleTime(new Date()),
      taskList: [],
      conditionType: '3',
      searchWord: '',
      showMonthPicker: false,
      currentMonth: new Date(),
      currentMonthStr: this.getCurrentMonth(new Date()),
      reportType: 1, // 流程状态
      loading: false,
      finished: false,
      refreshing: false,
      currentPage: 1,
      currentPageSize: 10,
      approvalList: [],
      total: 0, // 汇报管理审批列表总数
      showScreen: false, // 展示筛选
      selectStatus: 0,
      selectModel: 'all',
      columns: [],
      showApprovalModel: false,
      customFieldName: { text: 'text', values: 'values' },
      hasPermission: false,
      fromOld: false
    };
  },
  computed: {
    ...mapState(['initialData', 'dailyData', 'fromApp'])
  },
  // watch: {
  //   showApprovalModel(val) {
  //     console.log(val);
  //   }
  // },
  created() {
    if (this.initialData.v == 2) {
      this.type = 2;
    }
    this.setInitdata();
    this.getReportList();
    this.getReportApprovalList();
    this.writeDailyPermission();
  },
  activated() {
    this.showApprovalModel = false;
    this.approvalList = [];
    this.onRefresh();
  },
  mounted() {
    sessionStorage.removeItem('oldworktime');

    if (this.$route.query && this.$route.query.old) {
      this.fromOld = true;
      this.currentDateStr = this.handleTime(new Date('2024-04-30 00:00:00'));
      sessionStorage.setItem('oldworktime', 1);
    }

    //挂载成功后给pop事件绑定一个方法
    // 如果支持 popstate （一般移动端都支持）
    if (window.history && window.history.pushState) {
      if (this.fromOld == true) return;

      // 往历史记录里面添加一条新的当前页面的url
      history.pushState(null, null, document.URL);
      // 给 popstate 绑定一个方法用来监听页面返回
      window.addEventListener('popstate', this.handleBack, false); //false阻止默认事件
    }
  },
  //组件销毁后清除事件
  destroyed() {
    window.removeEventListener('popstate', this.handleBack, false); //false阻止默认事件
  },
  methods: {
    dayjs,
    handleReport() {
      this.showApprovalModel = true;
    },
    toApplyForm(item) {
      if (this.reportType == 5) return;
      this.$store.commit('setFromApp', false);
      this.$router.push({
        name: 'approveForm',
        query: {
          instanceId: item.instanceId
        }
      });
    },
    delApproval(item) {
      const params = {
        companyId: this.initialData.companyId,
        instanceId: item.instanceId
      };
      Dialog.confirm({
        title: '是否确认删除'
      })
        .then(() => {
          delApproval(params).then(res => {
            if (res.data.code === 0) {
              this.currentPage = 1;
              this.approvalList = [];
              this.getReportApprovalList();
            }
          });
        })
        .catch(() => {});
    },
    jumpApplyForm(item) {
      this.$store.commit('setFromApp', false);
      this.$router.push({
        name: 'applyForm',
        query: {
          instanceId: item.instanceId
        }
      });
    },
    writeReport(obj) {
      this.showApprovalModel = false;
      this.$store.commit('setFromApp', false);
      this.$router.push({
        name: 'applyForm',
        query: {
          modelId: obj.value
        }
      });
    },
    reset() {
      this.selectStatus = 0;
      this.selectModel = 'all';
    },
    confirmScreen() {
      this.showScreen = false;
      this.currentPage = 1;
      this.approvalList = [];
      this.getReportApprovalList();
    },
    renderColor(item) {
      let color = '';
      switch (item.approvalStatus) {
        case 0:
          if (item.kitValue == 99) {
            color = '#ffba19';
          } else {
            color = '#ffba19';
          }
          break;
        case 1:
          if (item.kitValue == 99) {
            color = '#1584ff';
          } else {
            color = '#00ca7b';
          }
          break;
        case 2:
          color = '#ff3b30';
          break;
        case 3:
          color = '#ff3b30';
          break;
        case 4:
          color = '#ff3b30';
          break;
        default:
          break;
      }
      return { color: color };
    },
    renderStatus(item) {
      let status = '';
      switch (item.approvalStatus + '') {
        case '0':
          if (item.kitValue == 99) {
            status = '未读';
          } else {
            status = '审核中';
          }
          break;
        case '1':
          if (item.kitValue == 99) {
            status = '已阅';
          } else {
            status = '通过';
          }
          break;
        case '2':
          status = '拒绝';
          break;
        case '3':
          status = '转交';
          break;
        case '4':
          status = '退回';
          break;
        case '5':
          status = '评论';
          break;
        case '7':
          status = '转交';
          break;
        default:
          break;
      }
      return status;
    },
    handleBack() {
      // fromOld 从新日报来的,要通过返回键触发
      if (this.fromOld) {
        // 线上新日报的url地址
        let prefix = 'https://coapp.veiban.com';

        // 兼容新日报的test环境
        let istest = process.env.VUE_APP_IS_TEST;
        if (istest && istest == '1') {
          prefix = 'http://192.168.3.197:8917';
        }

        let token = localStorage.token;
        let companyId = localStorage.companyId;
        let jumpurl = prefix + '/#/daily?&token=' + token + '&companyId=' + companyId;
        location.href = jumpurl;
        return;
      }

      if (!this.fromOld && this.fromApp) {
        window.location.href = 'jsToOc://back';
      }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.currentPage = 1;
      this.onLoad();
    },
    onLoad() {
      // if(this.refreshing) {
      //   this.approvalList = [];
      //   this.refreshing = false;
      //   this.currentPage = 0;
      // }
      // if (this.total > this.approvalList.length) {
      //   this.getReportApprovalList(false);
      // }
      // if (this.approvalList.length === this.total) {
      //   this.finished = true;
      // }
      this.getReportApprovalList();
      // this.currentPage++;
    },
    changeType(type) {
      if (type === 1 && this.type != 1) {
        this.type = type;
        this.getList();
      }
      if (type === 2 && this.type != 2) {
        this.type = type;
        this.currentPage = 1;
        this.approvalList = [];
        this.getReportApprovalList();
      }
    },
    getCurrentMonth(date) {
      return date.getFullYear() + '-' + this.checkTime(date.getMonth() + 1);
    },
    getReportList() {
      getReportList(this.initialData.companyId).then(res => {
        if (res.data.code === 0) {
          this.reportList = res.data.data.map(item => ({ text: item.modelName, value: item.modelId }));
          this.reportList.forEach(item => {
            this.columns.push({
              text: item.text,
              value: item.value
            });
          });
          this.reportList.unshift({
            text: '全部流程',
            value: 'all'
          });
        }
      });
    },
    writeDailyPermission() {
      const params = {
        companyId: this.initialData.companyId
      };
      writeDailyPermission(params).then(res => {
        if (res.data.code === 0) {
          this.hasPermission = res.data.data;
          if (!this.hasPermission) {
            this.approvalType = 2;
            this.conditionType = '4';
          }
        }
      });
    },
    handleTime(date) {
      return date.getFullYear() + '-' + this.checkTime(date.getMonth() + 1) + '-' + this.checkTime(date.getDate());
    },
    checkTime(i) {
      if (i < 10) {
        i = '0' + i;
      }
      return i;
    },
    changeMonth() {
      this.showMonthPicker = true;
    },
    changeTime() {
      this.showPicker = true;
    },
    changeStatus() {
      this.getList();
    },
    onConfirm(date) {
      this.currentDateStr = this.handleTime(date);
      this.showPicker = false;
      this.getList();
    },
    onMonthConfirm(date) {
      this.currentMonthStr = this.getCurrentMonth(date);
      this.showMonthPicker = false;
      this.currentPage = 1;
      this.approvalList = [];
      this.getReportApprovalList();
    },
    changeReportTabs(e) {
      if (e.target.id) {
        const target = e.target.id;
        this.reportType = parseInt(target);
        this.currentPage = 1;
        this.approvalList = [];
        this.getReportApprovalList();
      }
    },
    changeTitle(e) {
      if (e === 1) {
        this.conditionType = '3';
        this.approvalType = 1;
        this.getList();
      }
      if (e === 2) {
        this.conditionType = '4';
        this.approvalType = 2;
        this.getList();
      }
      if (e === 3) {
        this.conditionType = '5';
        this.approvalType = 3;
        this.getList();
      }
      if (e === 4) {
        this.conditionType = '0';
        this.approvalType = 4;
        this.getList();
      }
    },

    handleColor(item, index) {
      let color = '';
      console.log(item);
      if (item.taskStatus == 0) {
        return (color = 'color:#FFBE25');
      }
      if (item.taskStatus == 1 && item.isSendToMe == 0) {
        return (color = 'color:#FE773C');
      }
      if (item.taskStatus == 1 && item.isSendToMe == 1) {
        return (color = 'color:#1E1E1E');
      }
      if (item.taskStatus == 2) {
        return (color = 'color:#1AA15F');
      }
      if (item.taskStatus == 3) {
        return (color = 'color:#23AAF2');
      }
      return color;
    },
    handelRender(item) {
      let str = '';
      switch (item.taskStatus) {
        case 0:
          str = '未填写';
          break;
        case 1:
          str = '未审核';

          break;
        case 2:
          str = '已审核';
          break;
        case 4:
          str = '休息';
          break;
        case 5:
          str = '查看';
          break;
        case 6:
          str = '未排班';
          break;
        case 7:
          str = '请假';
          break;
        case 8:
          str = '未入职';
          break;
        default:
          str = '';
          break;
      }
      return str;
    },
    onSearch() {
      this.getList();
    },
    onReportSearch() {
      this.currentPage = 1;
      this.approvalList = [];
      this.getReportApprovalList();
    },
    jumpEdit() {
      this.$router.push('/daily-edit');
    },
    handleClick(item) {
      if (item.staffId === this.dailyData.staffId) {
        if (item.taskStatus === 0 || item.taskStatus == 4) {
          this.$router.push('/daily-edit');
        }
        if (item.taskStatus == 2 && item.reportId) {
          this.$router.push(`daily-detail/${item.reportId}`);
        }
        if (item.taskStatus === 6 || item.taskStatus === 7 || item.taskStatus === 8) {
          Toast('该日期为休息日，无法查看日报');
        } else {
          // this.$router.push(`/daily-edit/reportId=${item.reportId}&companyId=${item.companyId}`)
          this.$router.push({
            path: '/daily-edit',
            query: { reportId: item.reportId, companyId: item.companyId, currentDateStr: this.currentDateStr }
          });
        }
      } else if (item.staffId !== this.dailyData.staffId && item.reportId && item.isView === 0 && item.isSendToMe == 0) {
        this.$router.push(`daily-detail/${item.reportId}`);
      } else {
        Toast('该用户还没有填写日报,或者无权限，无法查看');
      }
    },
    async getReportApprovalList() {
      // const currentMonth = parseInt(this.currentMonthStr.slice(-2));
      // const currentYear = this.currentMonthStr.slice(0, 4);
      // let nextMonth;
      // if (currentMonth === 12) {
      //   nextMonth = currentYear + 1 + "-01-01 00:00:00";
      // } else if (currentMonth < 9) {
      //   nextMonth = currentYear + `-0${currentMonth + 1}-01 00:00:00`;
      // } else {
      //   nextMonth = currentYear + `-${currentMonth + 1}-01 00:00:00`;
      // }
      const params = {
        companyId: this.initialData.companyId,
        type: this.reportType,
        searchWord: this.searchWord || undefined,
        currentPage: this.currentPage,
        modelId: this.selectModel === 'all' ? 1 : this.selectModel,
        currentPageSize: this.currentPageSize,
        status: this.selectStatus
        // minInitiatorTime: this.currentMonthStr + "-01 00:00:00",
        // maxInitiatorTime: nextMonth,
        // minCompleteTime: this.completeTime.length > 0 ? this.dayjs(this.completeTime[0]).format("YYYY-MM-DD HH:mm:ss") : "",
        // maxCompleteTime: this.completeTime.length > 0 ? this.dayjs(this.completeTime[1]).format("YYYY-MM-DD HH:mm:ss") : "",
        // minActionTime: this.actionTime.length > 0 ? this.dayjs(this.actionTime[0]).format("YYYY-MM-DD HH:mm:ss") : "",
        // maxActionTime: this.actionTime.length > 0 ? this.dayjs(this.actionTime[1]).format("YYYY-MM-DD HH:mm:ss") : "",
      };
      await getReportApprovalList(params).then(res => {
        if (res.data.code === 0) {
          if (this.reportType == 1) {
            this.total = res.data.data.total;
          }
          this.currentPage++;
          this.loading = false;
          // if (this.approvalList.length >= this.total) {
          //   this.finished = true;
          // } else {
          //   this.finished = false;
          // }

          if (res.data.data) {
            let { records, total } = res.data.data;
            if (this.refreshing) {
              this.approvalList = [];
              this.refreshing = false;
            }
            if (this.approvalList.length === 0) {
              this.approvalList = records;
            } else {
              this.approvalList = this.approvalList.concat(records);
            }
            if (this.approvalList.length >= total) {
              this.finished = true;
            } else {
              this.finished = false;
            }
          }
        }
        //   if (this.approvalList.length === 0) {
        //     this.approvalList = res.data.data.records;
        //   } else if (this.total > this.approvalList.length) {
        //     this.currentPage++;
        //     this.approvalList = [...this.approvalList, ...res.data.data.records];
        //   }
        // }
      });
    },
    getList() {
      const data = {
        companyId: this.initialData.companyId,
        reportDate: this.currentDateStr,
        conditionType: this.conditionType,
        searchWord: this.searchValue,
        reportStatus: this.typeValue
      };
      getTaskList(data).then(res => {
        if (res.data.code === 0) {
          this.taskList = res.data.data;
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    setInitdata() {
      const params = {
        companyId: this.initialData.companyId
      };
      setMainStaff(params).then(res => {
        if (res.data.code === 0) {
          this.$store.commit('setDailyData', res.data.data);
          this.getList();
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    handleAvatar(item) {
      return item.avatar && item.avatar.slice(0, 4) == 'http' ? true : false;
    },
    renderName(name) {
      let str = '';
      if (name) {
        if (name.length === 1) {
          str = name;
        }
        if (name.length > 1) {
          str = name.substr(-2, 2);
        }
      }
      return str;
    }
  }
};
</script>

<style scoped>
.container {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 2rem;
  background: white;
  position: relative;
  padding-top: 1.71rem;
}
.title {
  width: 10rem;
  height: 1.71rem;
  background: #ffffff;
  position: fixed;
  z-index: 99;
  padding-left: 0.43rem;
  line-height: 1.71rem;
  top: 0;
  left: 0;
}
.title div {
  font-size: 0.48rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.work_report_tab {
  width: 9rem;
  height: 1rem;
  display: flex;
  text-align: center;
  margin: 0 auto;
}
.work_report_tab :nth-child(1) {
  width: 4.5rem;
  height: 1rem;
  background-color: #ffffff;
  border: 1px solid;
  line-height: 1rem;
  font-family: Source Han Sans CN;
  color: #1584ff;
  border-color: #1584ff;
}
.work_report_tab :nth-child(2) {
  width: 4.5rem;
  height: 1rem;
  border: 1px solid;
  background-color: #ffffff;
  line-height: 1rem;
  font-family: Source Han Sans CN;
  color: #1584ff;
  border-color: #1584ff;
}
.select {
  color: #ffffff !important;
  background-color: #1584ff !important;
}
.van-nav-bar /deep/.van-nav-bar__arrow {
  font-size: 22px;
  color: black;
}
.van-dropdown-menu {
  width: 3rem;
  /* height: 1rem; */
}
.van-dropdown-menu /deep/ .van-dropdown-item__option--active {
  color: #1584ff !important;
}
.van-dropdown-menu /deep/ .van-dropdown-menu__title--active {
  color: #1584ff !important;
}
.van-dropdown-menu /deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}
.van-search {
  background: #f9f9f9;
}
.van-search /deep/ .van-field__control {
  background: #ffffff;
}
.daily-search {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 45px;
  line-height: 45px;
  padding: 0 0.2rem;
}
.report_search {
  display: flex;
  justify-content: space-around;
  align-items: baseline;
  padding: 0 0.2rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.screen {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.end_date {
  font-family: Source Han Sans CN;
  color: #999999;
  font-size: 12px;
}
.search-tabs {
  width: 100%;
  height: 0.8rem;
  margin-top: 0.3rem;
  display: flex;
  justify-content: space-around;
}
.active {
  color: #1584ff;
}
.daily-item {
  width: 9.6rem;
  height: 2.45rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.4rem;
  margin-left: 0.4rem;
  border-bottom: 0.03rem solid #f3f3f3;
}
.member-info {
  display: flex;
  align-items: flex-start;
}
.member-bg {
  width: 40px;
  height: 40px;
  background: #1584ff;
  border-radius: 0.21rem;
  font-size: 0.32rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  margin-right: 8px;
}
.daily-submit {
  color: white;
  line-height: 1.17rem;
  text-align: center;
  width: 8.29rem;
  height: 1.17rem;
  background: #1584ff;
  box-shadow: 0rem 0.05rem 0.21rem 0rem #80bcff;
  border-radius: 0.21rem;
}
.daily-footer {
  width: 100%;
  height: 2rem;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.van-cell__value {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.screen_box {
  padding-left: 0.3rem;
  padding-bottom: 1.4rem;
  height: 10rem;
  overflow: auto;
}
.screen_status {
  width: 9.6rem;
  display: flex;
  flex-wrap: wrap;
}
.screen_status div {
  width: 3rem;
  height: 0.8rem;
  text-align: center;
  line-height: 0.8rem;
  background-color: #eff2f5;
  border-radius: 2px;
  margin-right: 0.2rem;
  margin-bottom: 0.2rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.screen_title {
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #000000;
  font-size: 0.5rem;
  text-align: center;
}
.screen_select_title {
  font-family: Source Han Sans CN;
  color: #000000;
  font-size: 0.4rem;
}
.btn_box {
  width: 9.6rem;
  display: flex;
  justify-content: space-around;
  position: fixed;
  bottom: 0.2rem;
  left: 0.1rem;
}
.reset_btn {
  width: 4.4rem;
  height: 1.2rem;
  background-color: #ffffff;
  border: 1px solid;
  border-color: #666666;
  border-radius: 8px;
  text-align: center;
  line-height: 1.2rem;
}
.confirm_btn {
  width: 4.4rem;
  height: 1.2rem;
  background-color: #1584ff;
  border-radius: 8px;
  box-shadow: 0px 2px 8px #80bcff;
  color: #ffffff;
  text-align: center;
  line-height: 1.2rem;
}
.member_img {
  width: 1rem;
  height: 1rem;
  margin-right: 8px;
  border-radius: 0.21rem;
}
.select {
  background-color: #1584ff !important;
}
</style>
